export const MEMBER_NAME_MESSAGE = '姓名須為 4～10 個字元（中文與空白算 2，英文算 1），且不可含數字或特殊符號';

const FORBIDDEN = new Set([
  '^', "'", '`', '!', '@', '#', '%', '&', '*', '+', '\\', '|', '"', '<', '>', '_', '[', ']', '~', '$', '-', '=', '{', '}', '/', '?', ';', '(', ')', ':',
  '＾', '＇', '‘', '’', '｀', '！', '＠', '＃', '％', '＆', '＊', '＋', '＼', '｜', '＂', '＜', '＞', '＿', '［', '］', '～', '＄', '－', '＝', '｛', '｝', '／', '？', '；', '（', '）', '：'
]);

function rejected(character) {
  const code = character.codePointAt(0);
  if (code <= 31 || code === 127) return true;
  if (/[0-9０-９]/u.test(character)) return true;
  if (FORBIDDEN.has(character)) return true;
  return /\p{Extended_Pictographic}/u.test(character);
}

function units(character) {
  if (character === ' ' || character === '\u3000') return 2;
  return character.codePointAt(0) > 255 ? 2 : 1;
}

export function memberNameError(name) {
  const value = String(name ?? '').trim();
  if (!value) return '';
  let total = 0;
  for (const character of value) {
    if (rejected(character)) return MEMBER_NAME_MESSAGE;
    total += units(character);
  }
  return total >= 4 && total <= 10 ? '' : MEMBER_NAME_MESSAGE;
}
